import { useAuth } from '@/app/providers/AuthProvider';
import type { UserRole } from '@/types/database';

export const STAFF_ROLES: UserRole[] = [
  'admin_clinance',
  'gerente_operacao',
  'consultor',
  'comercial',
];

export const MANAGER_ROLES: UserRole[] = ['admin_clinance', 'gerente_operacao'];

export function useRole() {
  const { profile } = useAuth();
  const role = profile?.role ?? null;

  return {
    role,
    isAdmin: role === 'admin_clinance',
    isManager: role !== null && MANAGER_ROLES.includes(role),
    isStaff: role !== null && STAFF_ROLES.includes(role),
    isConsultor: role === 'consultor',
    isComercial: role === 'comercial',
    isCliente: role === 'cliente',
    hasRole: (allowed: UserRole[]) => role !== null && allowed.includes(role),
  };
}
